export default __webpack_public_path__ + "static/media/truck.d06a2f0c.png";